module.exports = __webpack_public_path__ + "static/media/wilson-ng-photography.6255b1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wilson-ng-photography.png
// module id = 336
// module chunks = 0